import { useState } from "react";

import styles from "../styles/GetAppLanding.module.scss";
import logo from "../assets/abound-toi-logo.svg";
import closeIcon from "../assets/mobile-menu-close.svg";
import navChevron from "../assets/mobile-menu-chevron.svg";
import menuIcon from "../assets/mobile-menu-fill.svg";
import { navItems } from "./landingData";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`${styles.header} ${menuOpen ? styles.headerOpen : ""}`}>
      <div className={styles.headerInner}>
        <a className={styles.logoLink} href="/getapp/" aria-label="Abound">
          <img src={logo} alt="Abound by The Times of India" />
        </a>
        <nav className={styles.nav} aria-label="Primary navigation">
          {navItems.map((item) => (
            <a key={item} href={`#${item.toLowerCase().replace(/\s+/g, "-")}`}>
              {item}
            </a>
          ))}
        </nav>
        <div className={styles.headerActions}>
          <a className={styles.darkPill} href="https://accounts.joinabound.com/getapp/signup/v2?source=remittance">
            Get Started
          </a>
          <button
            className={`${styles.menuButton} ${
              menuOpen ? styles.menuButtonOpen : ""
            }`}
            type="button"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
            <span />
            <span />
            <img
              className={styles.mobileMenuIcon}
              src={menuIcon}
              alt=""
              aria-hidden="true"
            />
            <img
              className={styles.menuCloseIcon}
              src={closeIcon}
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </div>
      <div className={styles.mobileNav} aria-hidden={!menuOpen}>
        {navItems.map((item) => (
          <a
            className={styles.mobileNavLink}
            key={item}
            href={`#${item.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={closeMenu}
          >
            <span>{item}</span>
            <img src={navChevron} alt="" aria-hidden="true" />
          </a>
        ))}
        <div className={styles.mobileNavFooter}>
          <a
            className={styles.mobileNavCta}
            href="https://accounts.joinabound.com/getapp/signup/v2?source=remittance"
            onClick={closeMenu}
          >
            Get Started
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
